<template>
  <div class="flex">
    <gallery :images="fullImages" :index="index" @close="index = null"></gallery>
    <div class="titleTile">
      <div class="line line-left"></div>
      <div class="innerSpan specific">{{title}}</div>
      <div class="line line-right"></div>
    </div>
    <div class="firstImage">
      <img :src="this.firstImage" @click="index = 0" />
    </div>
    <div>

    
      <div
        class="imageGallery"
        v-for="(image, imageIndex) in images"
        :src="image"
        :key="imageIndex"
        @click="index = imageIndex + 1"
        :style="{ backgroundImage: 'url('+ image +')', width: '300px', height: '300px' }"
      ></div>
    </div>
  </div>
</template>

<script>
import jsonData from "../data/dataSpecificRenovation.json";
import jsonDataText from "../data/dataStudiosText.json";
import jsonDataTitle from "../data/dataSpecificRenovationTitle";
import VueGallery from "vue-gallery";

let p = [];
let q = [];
export default {
  name: "SpecificRenovation",
  components: { gallery: VueGallery },

  data() {
    return {
      txt: [],
      title: "",
      rawImages: jsonData,
      images: p,
      dataText: jsonDataText,
      dataTitle: jsonDataTitle,
      firstImage: null,
      fullImages: q,
      index: null,
    };
  },
  mounted() {
    if (this.images.length === 0) {
      for (let i in this.rawImages) {
        if (i === this.$route.params.id) {
          this.title = this.dataTitle[i];
          for (let image in this.rawImages[i]) {
            this.fullImages.push(
              require("@/assets/" +
                this.$route.params.id +
                "/" +
                this.rawImages[i][image])
            );
            if (image == 0)
              this.firstImage = require("@/assets/" +
                this.$route.params.id +
                "/" +
                this.rawImages[i][image]);
            else
              this.images.push(
                require("@/assets/" +
                  this.$route.params.id +
                  "/" +
                  this.rawImages[i][image])
              );
          }
        }
      }
    }
  },
  methods: {},
};
</script>

<style scope>
.titleTile {
  margin-top: 0;
}
.txt {
  vertical-align: top;
}
.firstImage {
  width: 100%;
}
.firstImage img {
  max-width: 100%;
  border-radius: 50px;
  max-height: 800px;
}
.txt > p {
  font-size: larger;
}
.flex {
  display: flex;
  flex-direction: column;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .secondImage img {
    max-width: 100%;
  }
  .secondImage .txt {
    width: 100%;
  }
  .firstImage img {
    border-radius: 0px;
  }
}
@media only screen and (min-width: 319px) and (max-width: 812px) {
  .line-left,
  .line-right {
    width: 100%;
  }
  .titleTile {
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>
